// The last thing between an exception and a white screen.
//
// The Settings boundary catches what Settings itself throws while rendering. It cannot catch
// the case that put this here: the permission switch threw inside a React STATE UPDATER, and
// an updater runs while re-rendering the component that OWNS the state — Root, above every
// boundary inside it. So the tree unmounted and Alan got a blank page with nothing to tap and
// no console error he could see.
//
// This sits above Root and above AppPreview, which is the only place that class of throw can
// be caught. It is deliberately dumb: no CMS lookup (the content bundle may be exactly what
// failed), no imports beyond React, no state to get wrong. Plain strings, on purpose —
// ct() reads a bundle this screen cannot assume loaded.
//
// Reload rather than "go back": by the time this renders, React has torn the tree down, so
// there is no earlier screen left to return to. Nothing is lost — every write is already
// saved or queued server-side.
const { Component } = React;

export class AppErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err: (err && err.message) || String(err) }; }
  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="min-h-screen min-h-[100dvh] flex items-center justify-center p-6 bg-slate-50" data-testid="app-error">
        <div className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 p-5 text-center">
          <h1 className="text-lg font-bold text-slate-800 mb-1">Something stopped working</h1>
          <p className="text-sm text-slate-500 mb-4">Nothing has been lost. Reload and carry on, and tell us what you were doing if it happens again.</p>
          <p className="text-[11px] text-slate-400 font-mono break-words mb-4" data-testid="app-error-detail">{this.state.err}</p>
          <button
            className="w-full bg-slate-900 text-white font-bold text-sm rounded-xl py-2.5"
            data-testid="app-error-reload"
            onClick={() => { try { window.location.reload(); } catch {} }}
          >Reload</button>
        </div>
      </div>
    );
  }
}
